import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = 'surveyTemplate/browse';

export interface IBrowseAllSurveyTemplatesQueryParams {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}

/**
 * Browse all published survey templates across every industry, deduplicated by template ID.
 * Returns lightweight template cards without full survey definitions.
 */
export function useBrowseAllSurveyTemplatesQuery(params: IBrowseAllSurveyTemplatesQueryParams = {}) {
	const { enabled = true, impersonationContext } = params;
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			const queryParams: Record<string, string> = {};

			return userSession.webServiceHelper.callAsync<Api.ISurveyTemplateCard[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams,
					urlPath: 'surveytemplate/browse',
				}),
				'GET'
			);
		},
		queryKey: [BASE_API_KEY, impersonationContext?.account?.id],
		enabled,
		staleTime: 5 * 60 * 1000,
	});
}

/**
 * Invalidates the browse-all survey templates query cache.
 */
export const invalidateBrowseAllSurveyTemplatesQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY] });
};
